<template>
  <div class="active-code-container">
    <div class="header">
      <navigation :showBack="!alreadyActivated" :title="'设备激活'" :onBack="pageBack" />
    </div>
    <div class="content">
      <div class="content-img"></div>
      <div class="content-info">
        <div class="active-code">{{activeCode}}</div>
        <div class="active-words">请在会议平板上输入上方激活码进行激活</div>
      </div>
    </div>
    <div class="footer" v-if="!alreadyActivated">
      <Customize-button :content="'完成'" :type="0" :onClick="handleComplete" />
    </div>
  </div>
</template>

<script>
import Navigation from '@components/NewComponents/Navigation/Navigation.vue';
import CustomizeButton from '@components/NewComponents/CustomizeButton/CustomizeButton.vue';

export default _extend({
  name: 'ReportCode',
  components: {
    Navigation,
    CustomizeButton
  },
  data () {
    const { activeCode, alreadyActivated } = this.$store.state.form;
    return {
      activeCode,
      alreadyActivated
    };
  },
  props: {
    switch: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    pageBack() {
      this.$router.back();
    },
    handleComplete() {
      this.$router.push(`/v2/?${window.location.search}`);
    }
  },
  created() {
    if (!this.$store.state.form.activeCode) {
      this.handleComplete();
    }
  }
});
</script>

<style lang="scss" scoped>
@import './ActiveCode.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/ActiveCode/ActiveCode.vue